/* =====================================================================
   LE PETIT BISCUIT FRANÇAIS — Barre d'achat collante (téléphone)
   Chantier 20, maquette validée par Fabien le 22/09/2026 :
   https://claude.ai/artifact/HcoceH6Ph5drD5M357q1hh

   S'appuie sur le bloc « Conditionnement » déjà construit par
   lpbf-multiformat.js (biscuit à message, #lpbf-mf) ou lpbf-coffret.js
   (coffrets à thème, #lpbf-fmt) : elle recopie leur total et clique
   leur vrai bouton. Aucun calcul de prix ici.

   Règles :
   - téléphone seulement (< 750 px) ;
   - visible dès qu'on a un peu défilé, tant que le vrai bouton
     « Ajouter au panier » n'est pas à l'écran ;
   - cachée quand le clavier est ouvert ;
   - s'il y a des lignes de message et qu'elles sont vides, le bouton dit
     « Écrire mon message » et ramène au premier champ ; le vrai bouton
     fait de même (avant : on pouvait ajouter un biscuit vierge) ;
   - remonte la bulle « Chat » (Shopify Inbox) au-dessus d'elle.
   ===================================================================== */
(function () {
  if (!window.matchMedia) return;
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var REDUIT = window.matchMedia('(prefers-reduced-motion: reduce)');

  var css = ''
    + '#lpbf-barre{position:fixed;left:0;right:0;bottom:0;z-index:40;background:#fff;border-top:1px solid #eadfd2;'
    + 'box-shadow:0 -6px 18px rgba(58,44,30,.10);padding:10px 14px calc(10px + env(safe-area-inset-bottom,0px));'
    + 'display:flex;align-items:center;gap:12px;transform:translateY(110%);transition:transform .22s ease;font-family:"Lato","Helvetica Neue",Arial,sans-serif;}'
    + '#lpbf-barre.on{transform:none;}'
    + '#lpbf-barre .i{flex:1;min-width:0;}'
    + '#lpbf-barre .t{display:block;font-family:Georgia,"Times New Roman",serif;font-size:19px;line-height:1.1;color:#3A2C1E;}'
    + '#lpbf-barre .s{display:block;font-size:12px;color:#6F6152;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}'
    + '#lpbf-barre button{flex:0 0 auto;height:48px;border:0;border-radius:26px;padding:0 18px;font:700 15px/1 "Lato","Helvetica Neue",Arial,sans-serif;'
    + 'background:#3A2C1E;color:#fff;cursor:pointer;box-shadow:0 6px 14px -6px rgba(58,44,30,.55);}'
    + '#lpbf-barre button.ecrire{background:#fff;color:#3A2C1E;box-shadow:inset 0 0 0 2px #3A2C1E;}'
    + '#lpbf-barre button:disabled{background:#c9beb0;color:#fff;box-shadow:none;}'
    + '#lpbf-barre button:focus-visible{outline:2px solid #B3702F;outline-offset:3px;}'
    + '@media (min-width:750px){#lpbf-barre{display:none !important;}}'
    + '@media (prefers-reduced-motion:reduce){#lpbf-barre{transition:none;}}';

  var bloc, vraiBouton, totalEl, barre, texte, detail, bouton, lignes = [], clavier = false, visibleCta = true;

  function trouver() {
    bloc = document.getElementById('lpbf-mf') || document.getElementById('lpbf-fmt');
    if (!bloc) return false;
    vraiBouton = document.getElementById('lpbf-cta') || document.getElementById('lpbf-fmt-cta');
    totalEl = document.getElementById('lpbf-tot') || document.getElementById('lpbf-fmt-tot');
    lignes = [].slice.call(document.querySelectorAll('input[name^="properties[Ligne"],textarea[name^="properties[Ligne"]'));
    return !!(vraiBouton && totalEl);
  }

  function message() {
    if (!lignes.length) return true; // coffret à thème : le message est déjà écrit
    return lignes.some(function (l) { return l.value && l.value.trim(); });
  }

  function resume() {
    // « Total · 16 biscuits » est écrit par le bloc Conditionnement
    var tl = bloc.querySelector('.tl'), nb = tl ? (tl.textContent.split('·')[1] || '').trim() : '';
    var choisis = [].slice.call(bloc.querySelectorAll('.row.on .ti')).map(function (e) { return e.textContent.trim(); });
    if (!choisis.length) return 'Aucun format choisi';
    var fmt = choisis.length > 1 ? choisis.length + ' formats' : choisis[0];
    return nb ? fmt + ' · ' + nb : fmt;
  }

  // 23/09/2026 : plus aucun format n'est choisi d'office, la barre doit donc savoir le dire
  // et ramener au bloc Conditionnement au lieu d'afficher un total à 0,00 €.
  function aucunFormat() { return !bloc.querySelector('.row.on'); }

  function versLesFormats() {
    var y = bloc.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: REDUIT.matches ? 'auto' : 'smooth' });
  }

  function versLeMessage() {
    var l = lignes[0]; if (!l) return;
    var y = l.getBoundingClientRect().top + window.pageYOffset - 220;
    window.scrollTo({ top: y, behavior: REDUIT.matches ? 'auto' : 'smooth' });
    setTimeout(function () { try { l.focus({ preventScroll: true }); } catch (e) { l.focus(); } }, REDUIT.matches ? 0 : 350);
  }

  // 24/09/2026 — on n'injecte plus rien dans la bulle Chat sur ordinateur : la
  // barre n'existe que sur téléphone, l'injection n'a rien à faire ailleurs.
  // (Retirée pendant la chasse au clic perdu dans Safari ; ce n'était PAS la
  // cause — voir txt() dans lpbf-multiformat.js — mais c'est plus propre ainsi.)
  function chat(haut) {
    var h = document.querySelector('shopify-chat');
    if (!h || !h.shadowRoot) return;
    if (!MOBILE.matches) {
      var vieux = h.shadowRoot.getElementById('lpbf-chat-css');
      if (vieux && vieux.parentNode) vieux.parentNode.removeChild(vieux);
      if (h.classList.contains('lpbf-haut')) h.classList.remove('lpbf-haut');
      return;
    }
    if (!h.shadowRoot.getElementById('lpbf-chat-css')) {
      var st = document.createElement('style'); st.id = 'lpbf-chat-css';
      st.textContent = '.activator{transition:transform .22s ease;} :host(.lpbf-haut) .activator{transform:translateY(-' + (barre.offsetHeight || 70) + 'px);}'
        + '@media (prefers-reduced-motion:reduce){.activator{transition:none;}}';
      h.shadowRoot.appendChild(st);
    }
    if (h.classList.contains('lpbf-haut') !== haut) h.classList.toggle('lpbf-haut', haut);
  }

  // Clavier ouvert = un champ de saisie a le focus. On le lit directement au lieu de
  // se fier aux seuls événements focusin/focusout, qui ne partent pas toujours.
  function saisie(el) { return !!(el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') && !/radio|checkbox|button|submit|range|color/.test(el.type)); }

  // 01/10/2026 — n'écrire dans la page QUE si la valeur change. maj() tourne à chaque pas de
  // défilement : réécrire à l'identique faisait ~500 modifications pour 20 pas, et sur iPhone,
  // quand un champ du message a encore le curseur, chaque modification ramène l'écran sur ce
  // champ (« la page saute et revient aux champs », signalé par Fabien). Même règle que txt()
  // dans lpbf-multiformat.js (bogue Safari du 24/09).
  function ecrire(el, v) { if (el.textContent !== v) el.textContent = v; }
  function classe(el, c, on) { if (el.classList.contains(c) !== on) el.classList.toggle(c, on); }
  var montre = null;

  function maj() {
    if (!barre || !trouver()) return;
    clavier = saisie(document.activeElement);
    var vide = aucunFormat();
    ecrire(texte, vide ? 'Choisissez un format' : totalEl.textContent);
    ecrire(detail, vide ? 'Coffret ou sachets' : resume());
    var m = message();
    ecrire(bouton, !m ? 'Écrire mon message' : (vide ? 'Choisir un format' : 'Ajouter au panier'));
    classe(bouton, 'ecrire', !m || vide);
    var off = !!(m && !vide && vraiBouton.disabled);
    if (bouton.disabled !== off) bouton.disabled = off;
    var montrer = MOBILE.matches && !clavier && !visibleCta && window.pageYOffset > 40;
    if (montrer !== montre) {
      montre = montrer;
      classe(barre, 'on', montrer);
      barre.setAttribute('aria-hidden', montrer ? 'false' : 'true');
      bouton.tabIndex = montrer ? 0 : -1;
    }
    chat(montrer);
  }

  function construire() {
    var st = document.createElement('style'); st.id = 'lpbf-barre-css'; st.textContent = css;
    document.head.appendChild(st);
    barre = document.createElement('div'); barre.id = 'lpbf-barre';
    barre.setAttribute('role', 'region'); barre.setAttribute('aria-label', 'Ajout au panier');
    var i = document.createElement('div'); i.className = 'i';
    texte = document.createElement('span'); texte.className = 't';
    detail = document.createElement('span'); detail.className = 's';
    i.appendChild(texte); i.appendChild(detail);
    bouton = document.createElement('button'); bouton.type = 'button';
    bouton.addEventListener('click', function () {
      if (!message()) { versLeMessage(); return; }
      if (aucunFormat()) { versLesFormats(); return; }
      if (vraiBouton && !vraiBouton.disabled) vraiBouton.click();
    });
    barre.appendChild(i); barre.appendChild(bouton);
    document.body.appendChild(barre);
  }

  function brancher() {
    // Le vrai bouton : pas de biscuit vierge non plus (phase de capture, avant lpbf-multiformat.js)
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('#lpbf-cta,#lpbf-fmt-cta');
      if (!b) return;
      trouver();
      if (!message()) { e.preventDefault(); e.stopImmediatePropagation(); versLeMessage(); }
    }, true);

    if ('IntersectionObserver' in window) {
      var obs = null, suivi = null;
      var suivre = function () {
        if (!trouver() || vraiBouton === suivi) return;
        if (obs) obs.disconnect();
        suivi = vraiBouton;
        obs = new IntersectionObserver(function (en) { visibleCta = en[0].isIntersecting; maj(); });
        obs.observe(vraiBouton);
      };
      suivre();
      new MutationObserver(function () { suivre(); maj(); }).observe(bloc.parentNode || document.body, { childList: true, subtree: true });
    }

    document.addEventListener('focusin', maj);
    document.addEventListener('focusout', function () { setTimeout(maj, 80); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', maj);
    document.addEventListener('input', maj);
    document.addEventListener('click', function () { setTimeout(maj, 30); });
    document.addEventListener('change', function () { setTimeout(maj, 60); });
    window.addEventListener('scroll', maj, { passive: true });
    // 01/10/2026 (chantier 37) — iPhone : après la saisie, le champ du message garde le curseur
    // (clavier ouvert même en défilant). En remontant, la barre d'adresse de Safari réapparaît,
    // la fenêtre change de hauteur et Safari recentre ce champ : « ça saute en remontant »
    // (Fabien). Dès que le champ actif sort de l'écran, on lui retire le curseur : le clavier se
    // ferme, le texte saisi reste. Rien ne change tant que le champ est visible (saisie en cours).
    window.addEventListener('scroll', function () {
      var a = document.activeElement;
      if (!saisie(a) || !a.closest || !a.closest('customization-component, #lpbf-mf, .product__info-container')) return;
      var r = a.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) a.blur();
    }, { passive: true });
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', maj);
  }

  function init() {
    var essais = 0;
    (function attendre() {
      if (trouver()) { construire(); brancher(); maj(); return; }
      if (++essais < 40) setTimeout(attendre, 150);
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
